import Components from "../components";

class FormAlert extends Components.Base {
  bind() {
    this.on("ajax:before", () => this.onSubmit());
  }

  onSubmit() {
    this.$el.find(".alert").alert("close");
    this.$el
      .find(".form-group.error")
      .removeClass("error")
      .find("span.help-inline")
      .remove();
    $(".main-inner .container>.alert").alert("close");
  }
}

Components.collection.register({
  selector: "form[data-remote]",
  klass: FormAlert,
});
